import React from "react";
import { Heading, Text } from "@chakra-ui/react";

const HeadingField = ({ field }) => (
  <>
    <Heading size="sm">{field.label}</Heading>
    {field.helpText ? <Text color="gray.500">{field.helpText}</Text> : null}
  </>
);

export default HeadingField;
